/* eslint-disable react/no-multi-comp, react/prop-types, react/display-name */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './carrousel.scss';
import classNames from '@app/ui/sports-components/utils/classNames';

const maxLength = 6;

const Carrousel = ({ images, currentId, change, hideWarning }) => {
    const [showImages, setShowImages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const newCurrentIndex = images.findIndex(im => im.id === currentId);
        setCurrentIndex(newCurrentIndex);
    }, [images, currentId]);

    useEffect(() => {
        const startIndex = Math.floor(currentIndex / maxLength) * maxLength;
        const newImages = images.slice(
            startIndex,
            Math.min(images.length, startIndex + maxLength),
        );
        setShowImages(newImages);
    }, [images, currentIndex]);

    const next = async () => {
        let newIndex = currentIndex;
        if (currentIndex === images.length - 1) {
            newIndex = 0;
        } else {
            newIndex = currentIndex + 1;
        }
        const { id: newId } = images[newIndex];
        await change(newId);
    };

    const previous = async () => {
        let newIndex = currentIndex;

        if (currentIndex === 0) {
            newIndex = images.length - 1;
        } else {
            newIndex = currentIndex - 1;
        }
        const { id: newId } = images[newIndex];
        await change(newId);
    };

    const _handleNavigation = async e => {
        switch (e.keyCode) {
            // Left Arrow
            case 37: {
                await previous();
                break;
            }

            // Right Arrow
            case 39: {
                await next();
                break;
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', _handleNavigation);
        return () => {
            document.removeEventListener('keydown', _handleNavigation);
        };
    }, [currentIndex, images, change]);

    return (
        <div className="gds-layout__column--md-12 -p-h-3 -p-t-2 -p-b-3 gds-flex gds-flex--align-center">
            <div className="gds-layout__column--md-1">
                <i
                    className="fas fa-arrow-circle-left gds-text--header-md -carrousel-arrow -cursor--pointer"
                    onClick={previous}
                />
            </div>
            <div className="gds-layout__column--md-10">
                <div className="gds-flex-grid__container">
                    <div className="gds-flex-grid__row">
                        {showImages.map((im, index) => {
                            const { imageUrl, id } = im;
                            const hasNoBB =
                                !im.boundingBoxes ||
                                im.boundingBoxes.length === 0;
                            const isSelected = currentId === id;
                            const classes = classNames(
                                'gds-ranker-card__item',
                                `gds-placement-image`,
                                'gds-bounding-box',
                                'gds-flex--justify-center',
                                '-m-b-2-lg',
                                '-cursor--pointer',
                                {
                                    'gds-bounding-box--active': isSelected,
                                },
                            );
                            const onClick = async () => {
                                await change(id);
                            };
                            return (
                                <div
                                    key={index}
                                    className="gds-flex-grid__item gds-flex-grid__item--half-gutter gds-flex-grid__item--desktop-6 gds-flex-grid__item--tablet-3 gds-flex-grid__item--mobile-1"
                                >
                                    <li className={classes} onClick={onClick}>
                                        <img
                                            className="gds-image"
                                            src={imageUrl}
                                        />
                                        {hasNoBB && !hideWarning && (
                                            <div className="gds-bounding-box-status -pos-abs gds-text--danger -text-center gds-text--header-xs">
                                                <i className="fa fa-exclamation-triangle" />
                                            </div>
                                        )}
                                        {!hasNoBB && !hideWarning && (
                                            <div className="gds-bounding-box-status -pos-abs gds-text--success -text-center gds-text--header-xs">
                                                <i className="fa fa-check-circle" />
                                            </div>
                                        )}
                                    </li>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="gds-layout__column--md-1">
                <i
                    className="fas fa-arrow-circle-right gds-text--header-md -carrousel-arrow -cursor--pointer"
                    onClick={next}
                />
            </div>
        </div>
    );
};

Carrousel.propTypes = {
    images: PropTypes.array,
    currentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    change: PropTypes.func,
    hideWarning: PropTypes.bool,
};

export default Carrousel;
